import React, { useMemo } from "react";
import "swiper/css";
import "swiper/css/pagination";
import BannerA from "../../../assets/images/Banner Registration A - Web.png";
import BannerB from "../../../assets/images/Banner Registration B - Web.png";
import BannerC from "../../../assets/images/Banner Registration C - Web.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import { useQuery } from "@tanstack/react-query";
import { getBannerLandingPage } from "../../../services/authApi";

const Carousel = () => {
  const { data: dataBanner, isFetching } = useQuery({
    queryKey: ["banner"],
    queryFn: () => getBannerLandingPage(),
    refetchOnMount: false,
  });

  const bannerArr = useMemo(() => {
    if (dataBanner && !isFetching)
      return dataBanner.map((banner) => banner.url_image);
    else return [BannerA, BannerB, BannerC];
  }, [dataBanner]);

  return (
    <Swiper
      spaceBetween={50}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      breakpoints={{
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 50,
        },
      }}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper transform  duration-200 hover:scale-110"
    >
      {bannerArr.map((banner, i) => (
        <SwiperSlide>
          <img
            src={banner}
            alt={`banner${i}`}
            key={i}
            className=" rounded-xl w-full"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Carousel;
